import { State } from '../state';

export const LegalSelectors = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    legal: (state: State) => state.Legal,
};
